import AOS from "aos";
import "aos/dist/aos.css";
import { Suspense, useEffect } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import Provider from "./Context/Provider";
import About from "./components/About/About";
import Contact from "./components/Contact/Contact";
import Footer from "./components/Footer/Footer";
import Header from "./components/Header/Header";
import NotFound from './components/NotFound/NotFound';
import Portfolio from './components/Portfolio/Portfolio';
import PortfolioDetails from "./components/PortfolioDetails/PortfolioDetails";
import Skills from "./components/Skills/Skills";
import Home from "./pages/Home";
import ErrorFallback from "./utils/ErrorBoundary";

function App() {

  useEffect(() => {
    AOS.init({
      duration: 1400
    });
    AOS.refresh();
  }, []);

  return (
    <Provider>
      <Router>
        <ErrorBoundary fallbackRender={ErrorFallback}>
          <Suspense fallback={<h1> ...Loading </h1>}>
            <Routes>
              <Route path="/" element={<Header />
              } >
                <Route path="/" element={<  Home />} />
                <Route path="/skill" element={<Skills />} />
                <Route path="/Projects" element={<Portfolio />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/portfolio_details/:id" element={<PortfolioDetails />} />
                <Route path="about" element={<About />} />
                <Route path="*" element={<NotFound />} />
              </Route>
            </Routes>
            <Footer />
          </Suspense>
        </ErrorBoundary>
      </Router>

    </Provider>
  );
}

export default App;
